(() => {
  const messages = {
    en: {
      contact: {
        securityCheckLoadError:
          'Could not load the security check. Please try again in a moment.',
        submitError:
          'An error occurred while sending your message. Please try again later.',
        validation: {
          nameRequired: '&#8613 Please enter your name',
          nameInvalid: '&#8613 Please enter a valid name',
          emailRequired: '&#8613 Please enter your email',
          emailInvalid: '&#8613 Please enter a valid email address',
          phoneInvalid: '&#8613 Please enter a valid telephone number',
          messageShort: '&#8613 Message is too short',
          messageLong: '&#8613 Message is too long',
        },
      },
      hero: {
        staticText: 'Your brand is ',
        words: [
          'bold...',
          'visual...',
          'iconic...',
          'digital...',
          'pixel-perfect...',
        ],
      },
      nav: {
        home: 'Home',
        services: 'Services',
        portfolio: 'Portfolio',
        contact: 'Contact',
        about: 'About',
        sectionNavigation: 'Section navigation',
        sectionNumber: 'Section {n}',
      },
      inputModal: {
        cancel: 'Cancel',
        ok: 'OK',
        editField: 'Edit field',
        chooseCountry: 'Choose country',
      },
    },
    uk: {
      contact: {
        securityCheckLoadError:
          'Не вдалося завантажити перевірку безпеки. Спробуйте ще раз за мить.',
        submitError:
          'Під час надсилання повідомлення сталася помилка. Спробуйте пізніше.',
        validation: {
          nameRequired: '&#8613 Будь ласка, введіть імʼя',
          nameInvalid: '&#8613 Будь ласка, введіть коректне імʼя',
          emailRequired: '&#8613 Будь ласка, введіть email',
          emailInvalid: '&#8613 Будь ласка, введіть коректний email',
          phoneInvalid: '&#8613 Будь ласка, введіть коректний номер телефону',
          messageShort: '&#8613 Повідомлення занадто коротке',
          messageLong: '&#8613 Повідомлення занадто довге',
        },
      },
      hero: {
        staticText: 'Твій бренд — ',
        words: [
          'сміливий...',
          'виразний...',
          'знаковий...',
          'сучасний...',
          'ідеальний...',
          'не як у всіх!',
        ],
      },
      nav: {
        home: 'Головна',
        services: 'Послуги',
        portfolio: 'Портфоліо',
        contact: 'Контакти',
        about: 'Про нас',
        sectionNavigation: 'Навігація по секціях',
        sectionNumber: 'Секція {n}',
      },
      inputModal: {
        cancel: 'Скасувати',
        ok: 'OK',
        editField: 'Редагувати поле',
        chooseCountry: 'Оберіть країну',
      },
    },
    es: {
      contact: {
        securityCheckLoadError:
          'No se pudo cargar la verificación de seguridad. Inténtalo de nuevo en un momento.',
        submitError:
          'Ocurrió un error al enviar tu mensaje. Inténtalo de nuevo más tarde.',
        validation: {
          nameRequired: '&#8613 Por favor, introduce tu nombre',
          nameInvalid: '&#8613 Por favor, introduce un nombre válido',
          emailRequired: '&#8613 Por favor, introduce tu correo',
          emailInvalid: '&#8613 Por favor, introduce un correo válido',
          phoneInvalid: '&#8613 Por favor, introduce un teléfono válido',
          messageShort: '&#8613 El mensaje es demasiado corto',
          messageLong: '&#8613 El mensaje es demasiado largo',
        },
      },
      hero: {
        staticText: 'Tu marca es ',
        words: [
          'audaz...',
          'expresiva...',
          'icónica...',
          'moderna...',
          'perfecta...',
        ],
      },
      nav: {
        home: 'Inicio',
        services: 'Servicios',
        portfolio: 'Portafolio',
        contact: 'Contacto',
        about: 'Nosotros',
        sectionNavigation: 'Navegación de secciones',
        sectionNumber: 'Sección {n}',
      },
      inputModal: {
        cancel: 'Cancelar',
        ok: 'OK',
        editField: 'Editar campo',
        chooseCountry: 'Elegir país',
      },
    },
  };

  const KNOWN_LANGS = new Set(Object.keys(messages));

  function resolveLang(rawLang) {
    const value = String(rawLang || '')
      .trim()
      .toLowerCase();
    if (!value) return 'en';
    const base = value.split('-')[0];
    if (base === 'ua') return 'uk';
    if (KNOWN_LANGS.has(base)) return base;
    return 'en';
  }

  function readByPath(obj, path) {
    if (!obj || !path) return undefined;
    return path.split('.').reduce((acc, key) => {
      if (acc && Object.prototype.hasOwnProperty.call(acc, key)) {
        return acc[key];
      }
      return undefined;
    }, obj);
  }

  const lang = resolveLang(
    document.documentElement.lang || navigator.language || 'en',
  );

  function get(path, fallback = undefined) {
    const fromCurrent = readByPath(messages[lang], path);
    if (fromCurrent !== undefined) return fromCurrent;
    const fromEn = readByPath(messages.en, path);
    if (fromEn !== undefined) return fromEn;
    return fallback;
  }

  function t(path, fallback = '') {
    const value = get(path, fallback || path);
    return typeof value === 'string' ? value : String(value);
  }

  window.NIW_I18N = {
    lang,
    messages,
    get,
    t,
  };
})();
